// API configuration
const API_CONFIG = {
  development: {
    baseURL: 'http://localhost:8000',
  },
  test: {
    baseURL: 'http://localhost:8000',
  },
  production: {
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  },
};

const rawEnv = process.env.NODE_ENV || 'development';
const environment = API_CONFIG[rawEnv] ? rawEnv : 'development';

export const API_BASE_URL = API_CONFIG[environment].baseURL;

export const API_ENDPOINTS = {
  portfolio: {
    bootstrap: '/api/v1/site/bootstrap',
    capabilities: '/api/v1/site/capabilities',
    material: (id) => `/api/v1/materials/${encodeURIComponent(id)}`,
    section: (id, sectionId) => `/api/v1/materials/${encodeURIComponent(id)}/sections/${encodeURIComponent(sectionId)}`,
    gallery: (id) => id ? `/api/v1/materials/${encodeURIComponent(id)}/gallery` : '/api/v1/site/gallery',
    questions: (id) => `/api/v1/materials/${encodeURIComponent(id)}/questions`,
  },
  chat: '/api/v1/chat',
  session: '/api/v1/session',
  chats: '/api/v1/chats',
  chatInfo: (chatId) => `/api/v1/chats/${chatId}`,
  chatHistory: (chatId) => `/api/v1/chats/${chatId}/history`,
  admin: {
    threads: '/api/v1/admin/threads',
    threadDetail: (threadId) => `/api/v1/admin/threads/${threadId}`,
    threadExport: (threadId) => `/api/v1/admin/threads/${threadId}/export`,
    proposals: '/api/v1/admin/calendar/proposals',
    confirmProposal: (proposalId) =>
      `/api/v1/admin/calendar/proposals/${proposalId}/confirm`,
    declineProposal: (proposalId) =>
      `/api/v1/admin/calendar/proposals/${proposalId}/decline`,
  },
  auth: {
    signup: '/api/v1/auth/signup',
    signin: '/api/v1/auth/signin',
    me: '/api/v1/auth/me',
    apple: '/api/v1/auth/apple',
    appleCallback: '/api/v1/auth/apple/callback',
    googleStart: '/api/v1/auth/google/start',
    googleCallback: '/api/v1/auth/google/callback',
    systemMessage: '/api/v1/auth/system-message',
  },
};

export const getApiUrl = (endpoint) => `${API_BASE_URL}${endpoint}`;
